import React from "react";
import assets from "../assets";
import Button from "../Components/Button";
import { motion } from "framer-motion";

const Section8 = ({ handleActivePopUp, variants }) => {
  return (
    <div className="section syntheSec">
      <div className="container-lg flex flexCol alignCenter relative">
        <motion.div
          variants={variants}
          initial={"initial"}
          whileInView={"inView"}
          transition={{ duration: 0.7, delay: 0.3 }}
          viewport={{ once: true }}
        >
          {assets.econCuadro}
        </motion.div>
        <motion.h3
          variants={variants}
          initial={"initial"}
          whileInView={"inView"}
          transition={{ duration: 0.7, delay: 0.5 }}
          viewport={{ once: true }}
          className="iconCorner textCenter width90 extraMbottom"
        >
          Build your project with synthetic assets, WEB3, mobile App exchange
          and DEFI projects, offer a VISA card on staked balance and more...
          <br />
          <br />
          <strong>
            We can help you build your MVP and launch your project.
          </strong>
        </motion.h3>
        <Button
          link={"#contact"}
          text={"Contact Developers"}
          handleActivePopUp={handleActivePopUp}
          popData="white"
        />
      </div>
    </div>
  );
};

export default Section8;
